<div class="identifier__content">
    <span class="external-id">{{cellValue['externalId']}}</span> <span class="order-id">{{cellValue['id']}}</span>
</div>
